import { render, staticRenderFns } from "./LaborDayHero.vue?vue&type=template&id=ad789694&"
import script from "./LaborDayHero.vue?vue&type=script&lang=js&"
export * from "./LaborDayHero.vue?vue&type=script&lang=js&"
import style0 from "./LaborDayHero.vue?vue&type=style&index=0&id=ad789694&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports